import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { BeatLoader } from 'react-spinners';
import { get } from '../../../../../server/actions';
import ReactTable from 'react-table';
import CalenderCarousel from '../CalenderCarousel/CalenderCarousel';
import NotificationSystem from 'react-notification-system';
import {
  _addNotificationError, getGradeNumberByText,
  groupBy, isRegularLunchOrderType, showFile, getSchoolGrades, getSchoolSessions
} from '../../../../../server/util'
import PrintLabels from '../../printLabels';
import SnackOrderReport from './snackOrderReport'
import MenuOptions from '../../../../Misc/MenuOptions/menuOptions';
import { getReportMenuOptions } from '../../../../Misc/MenuOptions/menuOptionsActions';
import { MealTypesReports, MenuOrderTypes } from '../../../../../server/constants';
import TmExportExcel from '../../../../Misc/tmExportExcel/tmExportExcel';
let download = require('downloadjs');
class OrdersReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      mealType: (getReportMenuOptions()[0] || ''),
      showDashboard: true,
      orderStudentWithMealDay: [],
      orderStudentWithMealWeek: [],
      showBy: 'Daily',
      date: moment(),
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
      wStartDate: moment().startOf('week'),
      wEndDate: moment().endOf('week'),
      pdfDayStartDate: moment().startOf('day'),
      pdfDayEndDate: moment().endOf('day'),
      pdfWeekStartDate: moment().startOf('week'),
      pdfWeekEndDate: moment().endOf('week'),
      selectedSession: 'All',
      gradesBySession: [],
      teacherSearch: '',
      dayGrade: 'All',
      weekGrade: 'All',
      haveExtraOrder: 'false',
    }
  }
  componentDidMount = () => {
    this._notificationSystem = this.refs.notificationSystem;
    this.bindGradeListBySession();
    this.setDay();
    this.setWeek();
  }
  setDay = () => {
    this.setState({
      date: moment(),
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
      toogle: !this.state.toogle,
    }, () => {
      this.getSchoolMealReport(moment().startOf('day'), moment().endOf('day'), 'Day');
    });
  }
  setWeek = () => {
    const from_date = moment().startOf('Week');
    const to_date = moment().endOf('Week');
    this.setState({
      week: from_date.format('MM/DD') + " - " + to_date.format('MM/DD'),
      date: from_date,
      wStartDate: from_date,
      wEndDate: to_date,
      toogle: !this.state.toogle,
    }, () => {
      this.getSchoolMealReport(from_date, to_date, 'week');
    });
  }
  setDayPdf = () => {
    const from_date = this.state.pdfDayStartDate;
    const to_date = this.state.pdfDayEndDate;
    this.getSchoolMealReportPdf(from_date, to_date, 'Day');
  }
  setWeekPdf = () => {
    const from_date = this.state.pdfWeekStartDate;
    const to_date = this.state.pdfWeekEndDate;
    this.getSchoolMealReportPdf(from_date, to_date, 'week');
  }
  buildDataFormatForExport = (sortBy) => {
    const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
    if (sortBy === 'Daily') {
      const dData = this.filterDaySessionGrades();
      const cols = [
        { Header: "Student First Name", width: 150, accessor: "studentFName" },
        { Header: "Student Last Name", width: 150, accessor: "studentLName" },
        { Header: 'Student Id', accessor: 'studentId' },
        {
          Header: "Grade", Cell: (props) => {
            return ((gradeGroup[props.grade] || [])[0] || {}).label || ''
          }
        },
        { Header: "Teacher", accessor: "teacherName" },
        {
          Header: "Items Name", Cell: props => {
            const itemList = Object.keys((props.mealOrderedByDate || {})[this.state.orderResponse] || {});
            const itemsWithQuantity = itemList.map(item => {
              const quantity = ((props.mealOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0;
              return `${item} - ${quantity}`;
            });
            return itemsWithQuantity.join(', ')
          }
        }
      ];

      if (this.state.haveExtraOrder) {
        cols.push({
          Header: "Extra Items", Cell: props => {
            const extraItems = Object.keys((props.extraOrderedByDate || {})[this.state.orderResponse] || {});
            const extraItemsWithQuantity = extraItems.map(item => {
              const quantity = ((props.extraOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0;
              return `${item} - ${quantity}`;
            });
            return extraItemsWithQuantity.join(', ')
          }
        });
      }
      cols.push({
        Header: "Sides", Cell: props => {
          const sideItems = Object.keys((props.sideOrderedByDate || {})[this.state.orderResponse] || {})
          return sideItems.join(', ')
        }
      });
      cols.push({ Header: "Allergies", Cell: props => (props.allergies || '') === '' ? 'No Allergies' : props.allergies });
      cols.push({ Header: "Served", accessor: "served" });

      return (
        [{
          columns: cols.map(col => {
            return { title: col.Header };
          }),
          data: dData.sort((a, b) => {
            if (a.studentFName < b.studentFName) return -1;
            if (a.studentFName > b.studentFName) return 1;
            return 0;
          }).map(item => {
            const itmDataRow = [];
            cols.map((col) => {
              if (col.Cell) {
                itmDataRow.push({ value: col.Cell(item) })
              } else {
                itmDataRow.push({ value: item[col.accessor] || '' });
              }
            })
            return itmDataRow
          })
        }]
      )
    } else {
      const { orderResponseWeek } = this.state;
      const wData = this.filterWeekSessionGrades()
      const wcols = [
        { Header: "Student First Name", accessor: "studentFName" },
        { Header: "Student Last Name", accessor: "studentLName" },
        { Header: 'Student Id', accessor: 'studentId' },
        {
          Header: "Grade", Cell: (props) => {
            return ((gradeGroup[props.grade] || [])[0] || {}).label || '';
          }
        },
        { Header: "Teacher", accessor: "teacherName" },
        {
          Header: "Allergy", Cell: props => {
            return (props.allergies || '') === '' ? 'No Allergies' : props.allergies
          }
        }
      ];
      for (let i = 1; i < 6; i++) {
        wcols.push({
          Header: moment(moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD').format('MM/DD'),
          accessor: moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD')
        });
        moment(this.state.date).subtract(1, 'days');
      }
      return (
        [{
          columns: wcols.map(col => {
            return { title: col.Header };
          }),
          data: wData.sort((a, b) => {
            if (a.studentFName < b.studentFName) return -1;
            if (a.studentFName > b.studentFName) return 1;
            return 0;
          }).map(item => {
            const itmDataRow = [];
            wcols.map((col) => {
              if (col.Cell) {
                itmDataRow.push({ value: col.Cell(item) })
              } else {
                itmDataRow.push({ value: item[col.accessor] || '' });
              }
            })
            return itmDataRow
          })
        }]
      )
    }
  }
  filterGradesBySelection = (type) => {
    const { dayGrade, weekGrade, selectedSession, gradesBySession, teacherSearch } = this.state;
    let gList = [];
    const _grades = (gradesBySession).map(g => g.value);
    if (selectedSession === 'All' && type == 'week' && weekGrade == 'All') {
      gList = [];
    }
    else if (selectedSession === 'All' && dayGrade == 'All' && type == 'Day') {
      gList = [];
    } else if (selectedSession !== 'All' && type == 'Day' && dayGrade == 'All') {
      gList = _grades;
    }
    else if (selectedSession !== 'All' && type == 'week' && weekGrade == 'All') {
      gList = _grades;
    } else {
      if (type == 'Day') {
        gList.push(dayGrade);
      } else {
        gList.push(weekGrade);
      }
    }
    return gList
  }
  getSchoolMealReportPdf = (startDate, endDate, type) => {
    const { dayGrade, weekGrade, selectedSession, gradesBySession } = this.state;
    const gList = this.filterGradesBySelection(type)
    this.setState({ loading: true });
    let url = '';
    if (this.state.mealType === MealTypesReports.LUNCH || this.state.mealType === MealTypesReports.BREAKFAST || this.state.mealType === MealTypesReports.SNACK || this.state.mealType === MealTypesReports.DINNER) {
      if (type === 'Day') {
        if (gList.length === 0) {
          url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
        }
        else {
          url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${gList.join(',')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
        }
      }
      else {
        if (gList.length === 0) {
          url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
        }
        else {
          url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${gList.join(',')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
        }
      }
      get(url).then((response) => {
        if (!response.ok) {
          if (response.status === 417) {
            return response.json();
          } else {
            throw Error(response.statusText);
          }
        }
        return response;
      }).then(resp => {
        this.setState({ loading: false });
        if (resp.statusCode === 417) {
          _addNotificationError(resp.statusMessage, this);
          throw Error(resp.statusMessage);
        } else {
          return resp.blob();
        }
      }).then(blob => {
        let filename = "Orders Reports for ";
        showFile(blob, filename);
      }).catch(error => {
        this.setState({ loading: false });
        console.log("Download Failed", error)
      })
    }
  }
  getSchoolMealReport = (startDate, endDate, type) => {
    this.setState({ loading: true });
    if (this.state.mealType === MealTypesReports.LUNCH || this.state.mealType === MealTypesReports.BREAKFAST ||
      this.state.mealType === MealTypesReports.SNACK || this.state.mealType === MealTypesReports.DINNER) {
      get(`/reports/schoolMealReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&isOrder=true&menuType=${this.state.mealType}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        console.log('response', response);
        return response.json();
      }).then(data => {
        if (type === 'week') {
          this.setState({ orderStudentWithMealWeek: data.studentWithMeal, orderResponseWeek: data.startDate, loading: false })
        }
        else {
          this.setState({ orderStudentWithMealDay: data.studentWithMeal, haveExtraOrder: data.havingExtraPreOrders, orderResponse: data.startDate, mealsByGradeAndDate: data.mealsByGradeAndDate, loading: false })
        }
      }).catch(error => {
        this.setState({ loading: false });
        console.log("Loading Report Failed", error)
      })
    }
  }
  getTotalOrderItemsByDay = (list, isORderCount = true) => {
    let count = 0;
    let formatedData = [];
    list.forEach(function (item) {
      let i = formatedData.findIndex(x => x.grade == item.grade);
      if (i <= -1) {
        const listByGrade = list.filter(x => x.grade === item.grade);
        if (isORderCount) {
          formatedData.push({ grade: item.grade, total: listByGrade.length });
        } else {
          let itemsCount = 0;
          listByGrade.map(bygrade => {
            Object.keys(bygrade.mealOrderedByDate || {}).map(dayDate => {
              Object.keys((bygrade.mealOrderedByDate || {})[dayDate]).map(item => {
                const itemVal = ((bygrade.mealOrderedByDate || {})[dayDate] || {})[item] || 0;
                itemsCount = itemsCount + itemVal;
              });
            });
          });
          formatedData.push({ grade: item.grade, total: itemsCount });
        }
      }
    });

    formatedData.forEach(item => {
      count = count + item.total
    })
    return count;
  }
  getTotalOrderItemsByWeek = (list, type = 'MealItems') => {
    let count = 0;
    let exCount = 0;
    list.forEach(item => {
      if (type === 'MealItems') {
        Object.keys(item.mealOrderedByDate || {}).forEach(x => {
          const valueList = Object.values((item.mealOrderedByDate || {})[x] || {});
          count = count + (valueList.reduce((a, b) => a + b, 0));
        })
      }
      if (type === 'ExtraItems') {
        Object.keys(item.extraOrderedByDate || {}).forEach(x => {
          const valueList = Object.values((item.extraOrderedByDate || {})[x] || {});
          exCount = exCount + (valueList.reduce((a, b) => a + b, 0));
        })
      }
    });

    if (type === 'MealItems')
      return count;
    else if (type === 'ExtraItems')
      return exCount;
    else
      return 0;
  }
  getTotalOrdersByWeek = (list) => {
    let count = 0;
    const formatedData = this.bindOrderCountByGradeInWeek(list);
    formatedData.forEach(item => {
      count = count + item.total
    })
    return count;
  }
  getTableData(data) {
    let resArr = [];
    const dataByGrade = groupBy(data, 'grade');
    let finalList = Object.keys(dataByGrade).map(gr => {
      let count = 0;

      (dataByGrade[gr] || []).map(itm => {
        let orderDates = [];
        Object.keys(itm.mealOrderedByDate || {}).forEach(date => {
          if (!orderDates.includes(date)) {
            orderDates.push(date);
          }
        });
        Object.keys(itm.extraOrderedByDate || {}).forEach(dt => {
          if (!orderDates.includes(dt)) {
            orderDates.push(dt);
          }
        });
        count = count + orderDates.length;
      })
      return { grade: gr, total: count }
    });
    return finalList || [];
    /* data.forEach(function (item) {
        let i = resArr.findIndex(x => x.grade == item.grade);
        if (i <= -1) {
            resArr.push({ grade: item.grade, total: data.filter(x => x.grade === item.grade).length });
        }
    });
    return resArr; */
  }
  bindOrderCountByGradeInWeek = (list) => {
    const _groupByGrades = groupBy(list, 'grade');
    let finalList1 = Object.keys(_groupByGrades).map(gr => {
      let count1 = 0;

      (_groupByGrades[gr] || []).map(itm => {
        let orderDates1 = [];
        Object.keys(itm.mealOrderedByDate || {}).forEach(date => {
          if (!orderDates1.includes(date)) {
            orderDates1.push(date);
          }
        });
        Object.keys(itm.extraOrderedByDate || {}).forEach(dt => {
          if (!orderDates1.includes(dt)) {
            orderDates1.push(dt);
          }
        })
        count1 = count1 + orderDates1.length;
      })
      return { grade: gr, total: count1 }
    });
    return finalList1 || [];
  }
  getTableData(data) {
    let resArr = [];
    data.forEach(function (item) {
      let i = resArr.findIndex(x => x.grade == item.grade);
      if (i <= -1) {
        resArr.push({ grade: item.grade, total: data.filter(x => x.grade === item.grade).length });
      }
    });
    return resArr;
  }
  bindWeekDataTable = () => {
    const { orderResponseWeek, orderStudentWithMealWeek } = this.state;
    const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
    let items = [];
    const cols = [
      { Header: "Student", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
      {
        Header: "Grade", style: { textAlign: 'center', textTransform: 'capitalize' }, Cell: (props) => {
          return <span >{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
        }
      },
      { Header: "Teacher", accessor: "teacherName" },
      { Header: "Allergy", Cell: props => <span>{(props.original.allergies || '') === '' ? 'No Allergies' : props.original.allergies}</span> }
    ];
    for (let i = 1; i < 6; i++) {
      cols.push({
        Header: moment(moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD').format('MM/DD'),
        accessor: moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD'), width: 150, style: { textAlign: 'center' },
        Cell: (row) => {
          const _itemObj = (row.original.mealOrderedByDate || {})[moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD')] || {};
          return <ul>{Object.keys(_itemObj).map(item => <li key={item}>{`${item} - ${(_itemObj[item] || 0)}`}</li>)}</ul>
        }
      });
      moment(this.state.date).subtract(1, 'days');
    }


    return <ReactTable
      data={this.filterWeekSessionGrades()}
      columns={cols}
      defaultPageSize={10}
      className="-striped -highlight"
      noDataText='No data found' />
  }
  filterWeekSessionGrades = () => {
    const { selectedSession, weekGrade, gradesBySession, orderStudentWithMealWeek, teacherSearch } = this.state;
    const _grades = (gradesBySession).map(g => g.value);
    const finalArray = [];
    orderStudentWithMealWeek.map((itm, index) => {
      const itemObj = { ...orderStudentWithMealWeek[index] };
      const extraMealObj = orderStudentWithMealWeek[index];
      Object.keys(itm.mealOrderedByDate || {}).map((key, i) => {
        itemObj[key] = (Object.keys(itm.mealOrderedByDate[key] || {}) || []).join(', ') || '';
      });
      Object.keys(itm.extraOrderedByDate || {}).map((key, i) => {
        let _itemsArray = [];
        if ((itemObj[key] || '') !== '') {
          _itemsArray.push((itemObj[key] || ''))
        }
        const extraItemList = Object.keys(itm.extraOrderedByDate[key] || {});
        if (extraItemList.length > 0) {
          _itemsArray = [..._itemsArray, ...(extraItemList || [])]
        }

        itemObj[key] = _itemsArray.join(', ');
      });
      finalArray.push(itemObj);
    })
    let _filterData = [];
    if (selectedSession === 'All' && weekGrade == 'All') {
      _filterData = finalArray;
    } else if (selectedSession !== 'All' && weekGrade == 'All') {
      _filterData = finalArray.filter(item => {
        return _grades.includes(item.grade)
      });
    } else {
      _filterData = finalArray.filter(item => item.grade === weekGrade)
    }
    return (teacherSearch || '').length > 0 ? _filterData.filter(item => item.teacherName.toLowerCase().startsWith((teacherSearch || '').toLowerCase())) : _filterData;
  }
  bindWeekSummary = () => {
    const data = this.filterWeekSessionGrades()
    return <ul style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
      <li><label className="color-1">{'Total Orders: '}</label>  <strong className="color-4">{this.getTotalOrdersByWeek(data)}</strong></li>
      <li><label className="color-1">{'Total Items: '}</label>  <strong className="color-4"> {this.getTotalOrderItemsByWeek(data || [], 'MealItems')}</strong></li>
      <li><label className="color-1">{'Total Extra Items: '}</label>  <strong className="color-4"> {this.getTotalOrderItemsByWeek(data || [], 'ExtraItems')}</strong></li>
    </ul>
  }
  filterDaySessionGrades = () => {
    const { selectedSession, dayGrade, gradesBySession, teacherSearch } = this.state;
    const _grades = (gradesBySession).map(g => g.value);
    let _filterData = [];
    if (selectedSession === 'All' && dayGrade == 'All') {
      _filterData = this.state.orderStudentWithMealDay;
    } else if (selectedSession !== 'All' && dayGrade == 'All') {
      _filterData = this.state.orderStudentWithMealDay.filter(item => {
        return _grades.includes(item.grade)
      });
    } else {
      _filterData = this.state.orderStudentWithMealDay.filter(item => item.grade === dayGrade)
    }
    return (teacherSearch || '').length > 0 ? _filterData.filter(item => item.teacherName.toLowerCase().startsWith((teacherSearch || '').toLowerCase())) : _filterData;
  }
  bindDayTable = (extraOrder) => {
    const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
    if (extraOrder) {
      return <ReactTable style={{ textAlign: 'center' }}
        data={this.filterDaySessionGrades()}
        columns={[{ Header: "Student Name", width: 150, accessor: "studentFName", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
        {
          Header: "Grade", style: { textAlign: 'center', textTransform: 'capitalize' }, Cell: (props) => {
            return <span>{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
          }
        },
        { Header: "Teacher", accessor: "teacherName" },
        {
          Header: "Items Name", Cell: props => {
            let itemList = Object.keys((props.original.mealOrderedByDate || {})[this.state.orderResponse] || {});
            return <ul>{itemList.map(item => {
              return <li key={item}>{`${item} - ${(((props.original.mealOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0)}`}</li>
            })}</ul>
          }
        },
        {
          Header: "Extra Items", Cell: props => {
            let itemList = Object.keys((props.original.extraOrderedByDate || {})[this.state.orderResponse] || {});
            return <ul>{itemList.map(item => <li key={item}>{`${item} - ${(((props.original.extraOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0)}`}</li>)}</ul>
          }
        },
        {
          Header: "Sides", Cell: props => {
            let itemList = Object.keys((props.original.sideOrderedByDate || {})[this.state.orderResponse] || {});
            return <ul>{itemList.map(item => <li key={item}>{`${item} - ${(((props.original.sideOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0)}`}</li>)}</ul>
          }
        },
        { Header: "Allergies", Cell: props => <span>{(props.original.allergies || '') === '' ? 'No Allergies' : props.original.allergies}</span> },
        { Header: "Served", accessor: "served" }]}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText='No data found'
        showPagination={true}
      />
    } else {
      return <ReactTable style={{ textAlign: 'center' }}
        data={this.filterDaySessionGrades()}
        columns={[{ Header: "Student Name", width: 150, accessor: "studentFName", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
        {
          Header: "Grade", style: { textAlign: 'center', textTransform: 'capitalize' }, Cell: (props) => {
            return <span>{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
          }
        },
        { Header: "Teacher", accessor: "teacherName" },
        {
          Header: "Items Name", Cell: props => {
            let itemList = Object.keys((props.original.mealOrderedByDate || {})[this.state.orderResponse] || {});
            return <ul>{itemList.map(item => {
              return <li key={item}>{`${item} - ${(((props.original.mealOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0)}`}</li>
            })}</ul>
          }
        },
        {
          Header: "Sides", Cell: props => {
            let itemList = Object.keys((props.original.sideOrderedByDate || {})[this.state.orderResponse] || {});
            return <ul>{itemList.map(item => {
              return <li key={item}>{`${item} - ${(((props.original.sideOrderedByDate || {})[this.state.orderResponse] || {})[item] || 0)}`}</li>
            })}</ul>
          }
        },
        { Header: "Allergies", Cell: props => <span>{(props.original.allergies || '') === '' ? 'No Allergies' : props.original.allergies}</span> },
        { Header: "Served", accessor: "served" }]}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText='No data found'
        showPagination={true}
      />
    }
  }
  bindDaySummary = (extraOrder) => {
    const data = this.filterDaySessionGrades();
    if (extraOrder) {
      return <ul style={{ WebkitColumnCount: 4, MozColumnCount: 4, columnCount: 4, textAlign: 'center' }}>
        <li><label className="color-1">{'Total Orders: '}</label>  <strong className="color-4">{data.length || 0}</strong></li>
        <li><label className="color-1">{'Total Items: '}</label>  <strong className="color-4">{this.getTotalOrderItemsByDay((data || []), false)}</strong></li>
        <li><label className="color-1">{'Total Extra Items: '}</label>  <strong className="color-4">{this.getTotalOrderExtraItemsByDay(data || [])}</strong></li>
        <li><label className="color-1">{'Total sides Items: '}</label>  <strong className="color-4">{this.getTotalSideItems(data || [])}</strong></li>
      </ul>
    } else {
      return <ul style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>

        <li><label className="color-1">{'Total Orders: '}</label>  <strong className="color-4">{data.length || 0}</strong></li>
        <li><label className="color-1">{'Total Items: '}</label>  <strong className="color-4">{this.getTotalOrderItemsByDay((data || []), false)}</strong></li>

        <li><label className="color-1">{'Total sides Items: '}</label>  <strong className="color-4">{this.getTotalSideItems(data || [])}</strong></li>
      </ul>
    }
  }
  getTotalSideItems = (list) => {
    let count = 0;
    list.forEach(item => {
      Object.keys(item.sideOrderedByDate || {}).forEach(x => {
        const valueList = Object.values((item.sideOrderedByDate || {})[x] || {});
        count = count + (valueList.reduce((a, b) => a + b, 0));
      });
    });
    return count
  }

  getSidesVal = (props) => {
    const { mealsByGradeAndDate, orderResponse } = this.state;
    let _val = '';
    Object.keys(mealsByGradeAndDate).map((val, key) => {
      if (props.original.grade === val) {
        _val = (mealsByGradeAndDate[val][moment(orderResponse).format('YYYY-MM-DD')] || '').toString();
      }
    })
    return _val;
  }
  getTotalOrderExtraItemsByDay = (list) => {
    let count = 0;
    list.forEach(item => {
      Object.keys(item.extraOrderedByDate || {}).forEach(x => {
        const valueList = Object.values((item.extraOrderedByDate || {})[x] || {});
        count = count + (valueList.reduce((a, b) => a + b, 0));
      });
    })
    return count
  }
  orderDashboard = () => {
    const { mealType } = this.state;
    const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');

    const dashboardWeekData = this.bindOrderCountByGradeInWeek(this.state.orderStudentWithMealWeek).sort((a, b) => {
      const aDisplay = ((gradeGroup[a.grade] || [])[0]).displayOrder;
      const bDisplay = ((gradeGroup[b.grade] || [])[0]).displayOrder;
      return (parseInt(aDisplay) - parseInt(bDisplay));
    })
    return (
      <div className="panel panel-p1 panel-primary">
        <div className="panel-heading text-center">
          <h3 className="panel-title">Orders</h3>
        </div>
        <div className="panel-body" style={{ padding: '5px' }}>
          <div className="row">
            <div className="col-sm-6 col-xs-6" style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ textAlign: '-webkit-center' }}>
                <div className="orders-report-counter" style={{ backgroundColor: '#b5d56a' }} onClick={() => {
                  this.setState({ showBy: 'Daily', showDashboard: false }, () => {
                    this.setDay();
                  })
                }}>
                  <p className="orders-report-counter-title"> Current Day</p>
                  <p className="orders-report-counter-title">{mealType === MealTypesReports.LUNCH ? (isRegularLunchOrderType() ? 'Lunch Orders Total' : 'Al a Carte Orders Total') : mealType === MealTypesReports.SNACK ? 'Snack Orders Total' : mealType === MealTypesReports.DINNER ? 'Dinner Orders Report' : 'Breakfast Orders Total'} </p>
                  <p className="orders-report-counter-value">{this.getTotalOrderItemsByDay(this.state.orderStudentWithMealDay || [])}</p>
                </div>
              </div>
              <div style={{ textAlign: '-webkit-center' }}>
                <div style={{ display: "table", padding: '10px' }}>
                  <ReactTable
                    data={this.getTableData(this.state.orderStudentWithMealDay).sort((a, b) => {
                      const aDisplay = ((gradeGroup[a.grade] || [])[0]).displayOrder;
                      const bDisplay = ((gradeGroup[b.grade] || [])[0]).displayOrder;
                      return (aDisplay - bDisplay);
                    })}
                    columns={[{
                      Header: "Grade", Cell: (props) => {
                        return <span >{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
                      }
                    },
                    { Header: "Total Orders", width: 150, accessor: "total" }]}
                    minRows={10}
                    className="-striped -highlight rtTable-Order"
                    noDataText='No data found'
                    showPagination={false}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xs-6" style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ textAlign: '-webkit-center' }}>
                <div className="orders-report-counter" style={{ backgroundColor: '#f0ad4e' }} onClick={() => {
                  this.setState({ showBy: 'Weekly', showDashboard: false }, () => {
                    this.setWeek();
                  })
                }}>
                  <p className="orders-report-counter-title"> Current Week</p>
                  <p className="orders-report-counter-title">{mealType === MealTypesReports.LUNCH ? (isRegularLunchOrderType() ? 'Lunch Orders Total' : 'Al a Carte Orders Total') : mealType === MealTypesReports.SNACK ? 'Snack Orders Total' : mealType === MealTypesReports.DINNER ? 'Dinner Orders Report' : 'Breakfast Orders Total'} </p>
                  <p className="orders-report-counter-value">{this.getTotalOrdersByWeek(this.state.orderStudentWithMealWeek || [])}</p>
                </div>
              </div>
              <div style={{ textAlign: '-webkit-center' }}>
                <div style={{ display: "table", padding: '10px' }}>
                  <ReactTable
                    data={dashboardWeekData
                    }
                    columns={[{
                      Header: "Grade",
                      Cell: (props) => {
                        return <span >{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
                      }
                    },
                    { Header: "Total Orders", width: 150, accessor: "total" }
                    ]}
                    minRows={10}
                    className="-striped -highlight rtTable-Order"
                    noDataText='No data found'
                    showPagination={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>)
  }
  downloadWeekExcel = () => {
    const _self = this;
    const startDate = this.state.pdfWeekStartDate;
    const endDate = this.state.pdfWeekEndDate;
    const gList = this.filterGradesBySelection('week');
    this.setState({ loading: true });
    let url = '';
    if (this.state.mealType === MealTypesReports.LUNCH || this.state.mealType === MealTypesReports.BREAKFAST || this.state.mealType === MealTypesReports.SNACK || this.state.mealType === MealTypesReports.DINNER) {
      if (gList.length === 0) {
        url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Excel&access_token=`
      }
      else {
        url = `/reports/schoolExportReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${gList.join(',')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Excel&access_token=`
      }
      get(url).then((response) => {
        if (!response.ok) {
          if (response.status === 417) {
            return response.json();
          }
        }
        console.log('response', response);
        return response;
      }).then(res => {
        if (res.statusCode === 417) {
          // _addNotificationError(res.statusMessage,this)
          throw Error(res.statusMessage);
        } else if (!res.statusCode === 200) {
          throw Error(res.errorMessage);
        } else {
          return res.blob();
        }
      }).then(blob => {
        this.setState({ loading: false })
        let filename = `${this.state.mealType}WeeklyOrdersReport`;
        download(blob,
          filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      }).catch(
        (error) => {
          let msg = ''
          if (typeof error === 'string') {
            msg = error;
          } else {
            msg = error.message;
          }
          _addNotificationError(msg, _self)
          this.setState({ loading: false })
          //console.log('Get Excel File response', error)
        }
      )

    }
  }
  bindDailyWeeklyReport = () => {
    const self = this;
    const { showBy, mealType, date, startDate, endDate, pdfDayStartDate, dayGrade, weekGrade,
      pdfDayEndDate, wStartDate, wEndDate, selectedSession, gradesBySession, haveExtraOrder } = this.state;
    const sessionList = getSchoolSessions(0, false);

    return (<Fragment>
      <div style={{
        display: 'inline-block',
        backgroundColor: 'transparent',
        margin: '1px',
        float: 'right',
        borderRadius: '3px'
      }}>
        <div className="btn-group">
          <button className="btn-link btn-sm dropdown-toggle" type="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
            <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
          </button>
          <ul className="dropdown-menu">
            <li>
              <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                onClick={() => (showBy == 'Daily') ? this.setDayPdf() : this.setWeekPdf()}
                target='_blank'
              ><i className="fa fa-file-pdf-o" /> Pdf</a>
            </li>
            {
              showBy === 'Daily' ?
                <li>
                  <TmExportExcel id="orderReport"
                    name={"Order report"}
                    filename={"Order Report"}
                    element={<a title="Click to Download Excel"
                      style={{
                        display: 'block',
                        padding: '3px 20px',
                        clear: 'both',
                        fontWeight: '400',
                        lineHeight: 1.42857143,
                        color: '#333',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer'
                      }}
                    ><i className="fa fa-file-excel-o" /> Excel</a>}
                    dataSet={this.buildDataFormatForExport(showBy)}
                  />

                </li> :
                <li>
                  <a title="Click to Download Excel" style={{ cursor: 'pointer' }} onClick={() => this.downloadWeekExcel()} ><i className="fa fa-file-excel-o" /> Excel</a>
                </li>
            }
          </ul>
        </div>
        {
          //(showBy == 'Daily' || showBy == 'Weekly')?
          <div className="btn-group">
            <button className="btn-link btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              style={{ color: '#fff', fontSize: '13px' }}>
              <i className="fa fa-print" aria-hidden="true"></i> Print Labels <span className="caret"></span>
            </button>
            <ul className="dropdown-menu">
              <li style={{ cursor: 'pointer' }}>
                <PrintLabels {...this} showButtonAs={'label'} buttonLabel={'All'} onlyExtraItems={false}
                  mealType={this.state.mealType}
                  grade={this.filterGradesBySelection(showBy == 'Weekly' ? 'week' : 'Day')}
                  schoolYear={sessionStorage.getItem('schoolYearValue')}
                  selectedDate={showBy == 'Weekly' ? moment(this.state.pdfWeekStartDate).format('YYYY-MM-DD') : moment(this.state.pdfDayStartDate).format('YYYY-MM-DD')}
                  selectedEndDate={showBy == 'Weekly' ? moment(this.state.pdfWeekEndDate).format('YYYY-MM-DD') : moment(this.state.pdfDayStartDate).format('YYYY-MM-DD')}
                  showErrorMessage={(message) => {
                    _addNotificationError(message, self);
                  }}
                  schoolId={sessionStorage.getItem('SchoolId')} />
              </li>
              <li style={{ cursor: 'pointer' }}>
                <PrintLabels {...this} showButtonAs={'label'} buttonLabel={'Extra Items'} onlyExtraItems={true}
                  mealType={this.state.mealType}
                  grade={this.filterGradesBySelection(showBy == 'Weekly' ? 'week' : 'Day')}
                  schoolYear={sessionStorage.getItem('schoolYearValue')}
                  selectedDate={showBy == 'Weekly' ? moment(this.state.pdfWeekStartDate).format('YYYY-MM-DD') : moment(this.state.pdfDayStartDate).format('YYYY-MM-DD')}
                  selectedEndDate={showBy == 'Weekly' ? moment(this.state.pdfWeekEndDate).format('YYYY-MM-DD') : moment(this.state.pdfDayStartDate).format('YYYY-MM-DD')}
                  showErrorMessage={(message) => {
                    _addNotificationError(message, self);
                  }}
                  schoolId={sessionStorage.getItem('SchoolId')} />
              </li>
            </ul>
          </div>
          // : null
        }
      </div>
      <div className="panel panel-p1 panel-primary">
        <div className="panel-heading text-center">
          <h3 className="panel-title">Orders</h3>
        </div>
        <div className="panel-body">
          <div className="row">
            <div className="col-md-5" style={{ paddingBottom: '10px' }}>
              <lable style={{
                padding: '20px 0px 0px 20px',
                fontWeight: '700',
              }}>{`${showBy} ${mealType === MealTypesReports.LUNCH ? (isRegularLunchOrderType() ? 'Lunch Orders Report' : 'Al a Carte Orders Report') : mealType === MealTypesReports.SNACK ? 'Snack Orders Report' : mealType === MealTypesReports.DINNER ? 'Dinner Orders Report' : 'Breakfast Orders Report'}`} </lable>
            </div>
            <div className="col-md-5">
              {
                showBy == 'Daily' ? <CalenderCarousel type={"Day"} date={date}
                  startDate={startDate} endDate={endDate}
                  dateChange={({ start, end, cDate }) => {
                    let _start = moment(start);
                    let _end = moment(end);
                    this.setState({
                      startDate: start, endDate: end, date: cDate, showBy: 'Daily',
                      pdfDayStartDate: moment(start), pdfDayEndDate: moment(end)
                    }, () => {
                      this.getSchoolMealReport(_start, _end, 'Day');
                    })
                  }} />
                  : <CalenderCarousel type={"Week"} date={date}
                    startDate={wStartDate} endDate={wEndDate}
                    dateChange={({ start, end, cDate }) => {
                      let _start = moment(start);
                      let _end = moment(end);
                      this.setState({
                        wStartDate: start, wEndDate: end, showBy: 'Weekly',
                        date: cDate, pdfWeekStartDate: moment(start), pdfWeekEndDate: moment(end)
                      }, () => {
                        this.getSchoolMealReport(_start, _end, 'week');
                      })
                    }} />
              }
            </div>
            <div className="col-md-2 text-right">
              <button className=" btn bg-color-4" onClick={() => {
                if (showBy == 'Daily') {
                  this.setDay();
                  this.setState({ showDashboard: true, dayGrade: 'All', selectedSession: 'All', teacherSearch: '' },);
                } else {
                  this.setWeek();
                  this.setState({ showDashboard: true, weekGrade: 'All', selectedSession: 'All', teacherSearch: '' });
                }
              }} style={{ margin: '0px 10px 10px 0px', color: "white" }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-offset-4 col-md-8 text-right">
              <form className="form-inline">
                <div className="form-group" style={{ paddingRight: '5px' }}>
                  <label htmlFor="teacherSearch" style={{ paddingRight: '5px' }}>Teacher: </label>
                  <input type="text" className="form-control" id="teacherSearch" value={this.state.teacherSearch}
                    onChange={(e) => this.setState({ teacherSearch: e.target.value }, () => {
                      this.bindGradeListBySession();
                    })} />
                </div>
                <div className="form-group" style={{ paddingRight: '5px' }}>
                  <label htmlFor="selectedSession" style={{ paddingRight: '5px' }}>Sessions: </label>
                  <select className="form-control"
                    id={"selectedSession"} value={selectedSession}
                    onChange={(e) => {
                      this.setState({ selectedSession: e.target.value, dayGrade: 'All', weekGrade: 'All' }, () => {
                        this.bindGradeListBySession();
                      })
                    }}>
                    <option value={"All"}>All</option>
                    {
                      sessionList.map((session, i) => {
                        return <option key={i}>{session.session}</option>
                      })
                    }
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="selectBy" style={{ paddingRight: '5px' }}>Grades: </label>
                  <select className="form-control" id={"selectBy"} value={showBy == 'Daily' ? dayGrade : weekGrade}
                    onChange={(e) => {
                      if (showBy == 'Daily') {
                        this.setState({ dayGrade: e.target.value });
                      } else {
                        this.setState({ weekGrade: e.target.value });
                      }
                    }}>
                    <option value={"All"}>All</option>
                    {(gradesBySession || []).map((item) => {
                      return <option
                        value={item.value}>{item.label}</option>
                    }, this)}
                  </select>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {showBy == 'Daily' ? this.bindDaySummary(haveExtraOrder) : this.bindWeekSummary()}
            </div>
            <div className="col-md-12">
              {showBy == 'Daily' ? this.bindDayTable(haveExtraOrder) : this.bindWeekDataTable()}
            </div>
          </div>

        </div>
      </div>
    </Fragment>)

  }
  bindGradeListBySession = () => {
    const { selectedSession } = this.state;
    let gradeList = getSchoolGrades(0, false);
    const sessionList = getSchoolSessions(0, false);
    if (selectedSession === 'All') {
      this.setState({ gradesBySession: gradeList });
    } else {
      const _sessionRec = sessionList.find(session => {
        return session.session == selectedSession;
      })
      if (_sessionRec) {
        this.setState({
          gradesBySession: gradeList.filter(grade => {
            return _sessionRec.grades.includes(grade.value);
          })
        });
      } else {
        this.setState({ gradesBySession: [] });
      }
    }
  }

  render() {
    const { showDashboard } = this.state;
    return (
      <Fragment>
        <NotificationSystem ref="notificationSystem" />
        <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
          <BeatLoader
            size={20}
            color={'#ea7066'}
            loading={this.state.loading}
          />
        </div>
        <div className="row">
          <div className="col-md-12 text-right">
            <MenuOptions menuOptionsList={getReportMenuOptions()}
              onOptionSelect={(type) => {
                this.setState({ mealType: type }, () => {
                  this.setWeek(); this.setDay();
                })
              }} selectedOption={(this.state.mealType)} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {
              showDashboard ? this.orderDashboard()
                : this.bindDailyWeeklyReport()
            }
          </div>
        </div>

      </Fragment>
    );
  }
}

export default OrdersReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/Orders/ordersReport.jsx